import React from 'react';
import Spinner from '@components/atoms/spinner/spinner';
import styles from './notification-loading-animation-v2.module.scss';

const NotificationsLoadingAnimationV2: React.FC = () => {
  return (
    <div className={styles.notificationLoadingAnimation}>
      <Spinner className={styles.notificationLoadingAnimation__icon} />
    </div>
  );
};

export default NotificationsLoadingAnimationV2;
